/**
 * Created with IntelliJ IDEA.
 * User: nzamuruev
 * Date: 24.01.13
 * Time: 11:55
 * To change this template use File | Settings | File Templates.
 */

import { BasicTrackingEvent } from "./BasicTrackingEvent";
import * as trackingEvents from "@goodgamestudios/tracking-event-types";

/**
 * Documentation:
 * https://docs.google.com/a/goodgamestudios.com/spreadsheet/ccc?key=0AlN2EPXCQVModDB1Z2FiTlF6dHVnWjduN1drSUtYa1E#gid=131
 */
export class GamePaymentShopClickEvent extends BasicTrackingEvent {
    public gameId: number;
    public networkId: number;
    public instanceId: number;
    public playerId: number;

    public sessionId: string;
    public date: string;

    public deviceId: number;
    public storeId: number;
    public connectionType: string;

    // Id of the clickSource. To get more info see the ClickSourceTrackingConstants class from toolBox
    public clickSourceId: number;
    // 0, if shop wasn't clicked. In other case - 1.
    public isShopClicked: number;

    constructor(referer: string) {
        super(referer);
    }

    public getVars(): trackingEvents.GamePaymentshopClick.Event {
        const vars: trackingEvents.GamePaymentshopClick.Event = {
            clickSourceId: this.clickSourceId,
            connectionType: this.connectionType,
            deviceId: this.deviceId,
            eventId: trackingEvents.GamePaymentshopClick.ID,
            event_mapping_version: 2,
            playerId: this.playerId,
            sessionId: parseInt(this.sessionId, 10),
            storeId: this.storeId,
        };

        // CORE-839
        //vars.date = date;

        return vars;
    }
}
